<form [formGroup]="form" (ngSubmit)="formService.submit()">

    <div class="page_title">
        <div class="row marges">
            <div class="col y_items_center">
                <h1 class="title">{{ 'form.user.title.modification.value' | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToList()">
                    {{ 'user.list.back.value' | translate }}
                </button>

                <!-- Soumission -->

                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <!-- Gestion des onglets (une fois le rôle choisi) -->

    <mat-tab-group #tabGroup>

        @for(tabItem of tabItems; track tabItem) {

            <mat-tab>
                <ng-template mat-tab-label>
                    <span>{{ tabItem.label | translate }}</span>
                    <span [ngClass]="offerFormTabValidationService.getTabLabelClasses(tabItem.tag, false)"></span>
                </ng-template>
                <ng-container *ngTemplateOutlet="tabItem.template"></ng-container>
            </mat-tab>

        }

    </mat-tab-group>

</form>

<!-- Saisie des informations entreprise associées au prestataire -->

<ng-template #societyInformations>

    <ng-container [formGroup]="form">

        @if(subscriptions.length && subscriptionsSociety.length) {
            @for(subscription of subscriptionsSociety; track subscription) {
                @if(subscription.toDelete) {

                    <div class="col_12 form-group">
                        <p class="message-help background_warning">
                            <mat-icon>info</mat-icon>{{'form.user.subscription.delete_request.value' | translate: {date: (subscription.toDeleteAt | date : 'shortDate' : null: localeId)} }}
                        </p>
                    </div>
                }
            }
        }

        <div formGroupName="society">

            <p>
                <strong>{{'form.user.createdAt.value' | translate}} : </strong>
                {{createdAt | date : 'shortDate' : null: localeId }}
            </p>

            <!--    Dernière connexion de tous les comptes confondus  -->
            <p>
                @if(society.lastLoginAt) {
                    <strong>{{ 'user.lastLoginAt.value' | translate }} : </strong>
                    {{society.lastLoginAt | date: 'short'}}
                } @else {
                    <strong>{{ 'user.lastLoginAt.value' | translate }} : </strong>
                    {{'none' | translate}}
                }
            </p>

            <!--    Nombre de connexions des users de la société  -->

            <p>
                <strong>{{ 'user.nbrOfConnection.value' | translate }} : </strong>
                {{society.totalNbrOfConnections}}
            </p>

            @if(userHasOneOfRole(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']) && hasRole('ROLE_PROVIDER')) {

                <p>
                    <strong>{{ 'provider.reference.value' | translate }} :</strong>
                    {{ societyProvider }}
                </p>

            }

            <p> <!--    Nombre de licences  -->
                <strong>{{ 'user.list.licences.value' | translate }} : </strong>
                {{ society.countPublishedOffers }}
            </p>

            <p>   <!--Nombres offres dans le catalogue -->
                <strong>{{ 'user.list.countOffers.value' | translate }} : </strong>
                {{ society.countCatalogOffers }}
            </p>

            <p> <!--Nombres d'offres restreintes -->
                <strong>{{ 'user.list.countOffersRestricted.value' | translate }} : </strong>
                {{ society.countRestrictedOffers }}
            </p>

            <p> <!--Nombres d'offres en brouillon -->
                <strong>{{ 'user.list.countOffersUnpublished.value' | translate }} : </strong>
                {{ society.countDraftOffers }}
            </p>

            <p> <!--Nombres de canaux crées  -->
                <strong>{{ 'user.list.countChannels.value' | translate }} : </strong>
                {{ society.countEnableChannels }}
            </p>

            <p> <!--Nombres de collaborateurs -->
                <strong>{{ 'user.list.countCollaborators.value' | translate }} : </strong>
                {{ society.countCollaborators }}
            </p>

            <p> <!-- Nombre d'offres dans la marketplace  -->
                <strong>{{ 'user.list.marketplace.value' | translate }} : </strong>
                {{ society.totalMarketplaceOffers }}
            </p>

            <div class="form_part">
                <p class="title_part">{{ 'form.user.title.societyInformations.society.value' | translate }}</p>
            </div>

            <div class="row marges ligne_form">
                <div class="col_12 col_md_6">
                    <!-- Nom société -->
                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="name" id="nameSociety" required="required">
                        <label for="nameSociety">{{'form.user.fields.name.value' | translate}}</label>
                        @if(societyForm.get('name').errors && (societyForm.get('name').dirty || societyForm.get('name').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('name').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
                <div class="col_12 col_md_6">
                    <!-- Site web -->
                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="mainWebsite" id="mainWebsite" required="required">
                        <label for="mainWebsite">{{'form.user.fields.website.value' | translate}}</label>
                        @if(societyForm.get('mainWebsite').errors && (societyForm.get('mainWebsite').dirty || societyForm.get('mainWebsite').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('mainWebsite').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                    @if(societyForm.get('mainWebsite').errors.pattern) {
                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">

                <div class="col_12 col_md_6">

                    <!-- Locale -->

                    <div class="form-group">
                        <select class="form-control" id="locale" formControlName="locale" required="required">
                            <option value=""></option>
                            @for((locale of locales$ | async); track locale) {
                                <option [value]="locale.id">
                                    {{ locale.label | translate }}
                                </option>
                            }
                        </select>
                        <label class="required" for="locale">{{ 'form.user.fields.society.locale.value' | translate }}</label>
                        @if(societyForm.get('locale').errors && (societyForm.get('locale').dirty || societyForm.get('locale').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('locale').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>

                <div class="col_12 col_md_6">

                    <!-- Type -->

                    <div class="form-group">
                        <select class="form-control" id="type" formControlName="type" required="required">
                            <option value=""></option>
                            @for((type of types$ | async); track type) {
                                <option [value]="type.id">
                                    {{ type.label | translate }}
                                </option>
                            }
                        </select>
                        <label class="required" for="type">{{ 'form.user.fields.society.type.value' | translate }}</label>
                        @if(societyForm.get('type').errors && (societyForm.get('type').dirty || societyForm.get('type').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('type').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">
                <div class="col_12 col_md_6">

                    <!-- Raison sociale -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="corporateName" id="corporateName" required="required">
                        <label for="corporateName">{{'form.user.fields.corporateName.value' | translate}}</label>
                        @if(societyForm.get('corporateName').errors && (societyForm.get('corporateName').dirty || societyForm.get('corporateName').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('corporateName').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>

                <div class="col_12 col_md_6">

                    <!-- Immatriculation -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="registration" id="immatriculation" [required]="hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])">
                        <label for="immatriculation">{{'form.user.fields.immatriculation.value' | translate}}</label>
                        @if(societyForm.get('registration').errors && (societyForm.get('registration').dirty || societyForm.get('registration').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if (societyForm.get('registration').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                        @if(hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {
                            <span class="message-help">
                                <mat-icon class="tooltip_icon">info</mat-icon> {{ 'form.user.fields.immatriculation.help.value' | translate }}
                            </span>
                        }
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">
                <div class="col_12 col_md_6">

                    <!-- Code APE -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="businessActivityCode" id="businessActivityCode" >
                        <label for="businessActivityCode">{{'form.user.fields.businessActivityCode.value' | translate}}</label>
                        @if(societyForm.get('businessActivityCode').errors && (societyForm.get('businessActivityCode').dirty || societyForm.get('businessActivityCode').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('businessActivityCode').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>

                <div class="col_12 col_md_6">

                    <!-- Capital -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="capital" id="capital">
                        <label for="capital">{{'form.user.fields.capital.value' | translate}}</label>
                        @if(societyForm.get('capital').errors && (societyForm.get('capital').dirty || societyForm.get('capital').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('capital').errors.isRequired) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">

                <div class="col_12 col_md_6">

                    <!-- Siren -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="identificationNumber" id="siren" required="required">
                        <label for="siren">{{'form.user.fields.siren.value' | translate}}</label>
                        @if(societyForm.get('identificationNumber').errors && (societyForm.get('identificationNumber').dirty || societyForm.get('identificationNumber').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('identificationNumber').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>

                <div class="col_12 col_md_6">

                    <!-- immatriculation RCS  -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="rcsRegistration" id="rcsRegistration">
                        <label for="rcsRegistration">{{'form.user.fields.rcsRegistration.value' | translate}}</label>
                        @if(societyForm.get('rcsRegistration').errors && (societyForm.get('rcsRegistration').dirty || societyForm.get('rcsRegistration').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('rcsRegistration').errors.isRequired) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

            @if(hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {
                <div class="row marges ligne_form">

                    <div class="col_12 col_md_6">

                        <!-- Garantie financière  -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="financialGuarantee" id="financialGuarantee" required="required">
                            <label for="financialGuarantee">{{'form.user.fields.financialGuarantee.value' | translate}}</label>
                            @if(societyForm.get('financialGuarantee').errors && (societyForm.get('financialGuarantee').dirty || societyForm.get('financialGuarantee').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('financialGuarantee').errors.isRequired) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                            <span class="message-help">
                            <mat-icon class="tooltip_icon">info</mat-icon> {{ 'form.user.fields.financialGuarantee.help.value' | translate }}
                        </span>
                        </div>
                    </div>

                    <div class="col_12 col_md_6">

                        <!-- Assurance responsabilité civile professionnelle -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="insurancePolicy" id="insurancePolicy" required="required">
                            <label for="insurancePolicy">{{'form.user.fields.insurancePolicy.value' | translate}}</label>
                            @if(societyForm.get('insurancePolicy').errors && (societyForm.get('insurancePolicy').dirty || societyForm.get('insurancePolicy').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('insurancePolicy').errors.isRequired) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                            <span class="message-help">
                            <mat-icon class="tooltip_icon">info</mat-icon> {{ 'form.user.fields.insurancePolicy.help.value' | translate }}
                        </span>
                        </div>
                    </div>

                </div>
            }

            <div class="row marges ligne_form">

                <div class="col_12 col_md_6">

                    <!-- Numéro de TVA -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="vatNumber" id="vatNumber">
                        <label for="vatNumber">{{'form.user.fields.vatNumber.value' | translate}}</label>
                        @if(societyForm.get('vatNumber').errors && (societyForm.get('vatNumber').dirty || societyForm.get('vatNumber').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('vatNumber').errors.isRequired) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                        <span class="message-help">
                            <mat-icon class="tooltip_icon">info</mat-icon>
                            {{ 'form.user.fields.vatNumber.help.value' | translate }}
                        </span>
                    </div>
                </div>

            </div>

            <!-- Adresses -->

            <ng-container formArrayName="addresses">

                @if(isAddressToDisplay('mailing')) {
                    <div class="row marges ligne_form">

                        <ng-container *ngTemplateOutlet="formAddress;context:{controlIndex: getAddressControlIndexByType('mailing')}"></ng-container>

                    </div>
                }

                @if(hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <div class="checkbox">
                                    <input type="checkbox" id="differentBillingAddress" [(ngModel)]="differentBillingAddress" [ngModelOptions]="{standalone: true}" (ngModelChange)="resetAddresses()">
                                    <label for="differentBillingAddress">{{ 'bill.address.different.question.value' | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                @if(isAddressToDisplay('billing')) {
                    <div class="row marges ligne_form">

                        <ng-container *ngTemplateOutlet="formAddress;context:{controlIndex: getAddressControlIndexByType('billing')}"></ng-container>

                    </div>
                }

            </ng-container>


            <div class="row marges ligne_form">
                <div class="col_12 col_md_6">
                    <!-- Email générique (pour les échanges clients) -->
                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="email" id="email" required="required">
                        <label for="email">{{'form.user.fields.email.society.value' | translate}}</label>
                        @if(societyForm.get('email').errors && (societyForm.get('email').dirty || societyForm.get('email').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('email').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                    @if(societyForm.get('email').errors.pattern) {
                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
                <div class="col_12 col_md_6">
                    <!-- Téléphone générique (pour les échanges clients) -->
                    <div class="form-group">

                        <app-core-intl-tel-input [formGroup]="societyForm" [controlName]="'phone'" customPlaceholder="{{'form.user.fields.phone.value' | translate}}"></app-core-intl-tel-input>

                        @if(societyForm.get('phone').errors && (societyForm.get('phone').dirty || societyForm.get('phone').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('phone').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                    @if(societyForm.get('phone').errors.validatePhoneNumber) {
                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

            <!-- Email de facturation différent -->

            <ng-container >

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <div class="checkbox">
                                <input type="checkbox" id="differentBillingEmail" [(ngModel)]="differentBillingEmail" [ngModelOptions]="{standalone: true}" (ngModelChange)="societyForm.get('billingEmail').patchValue(differentBillingEmail ? '' : societyForm.get('email').value)">
                                <label for="differentBillingEmail">{{ 'form.user.fields.emailFacturation.title.value' | translate }}</label>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-container>

            @if(differentBillingEmail) {

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Email de facturation -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="billingEmail" id="billingEmail" >
                            <label for="billingEmail">{{'form.user.fields.emailFacturation.value' | translate}}</label>
                            @if(societyForm.get('billingEmail').errors && (societyForm.get('billingEmail').dirty || societyForm.get('billingEmail').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('billingEmail').errors.isRequired) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(societyForm.get('billingEmail').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

            }

            <ng-template #formAddress let-i="controlIndex">

                <ng-container [formGroup]="form">

                    <ng-container formGroupName="society">

                        <ng-container formArrayName="addresses">

                            <ng-container [formGroupName]="indexAsString(i)">

                                <div class="col_12">

                                    <div class="row marges ligne_form">
                                        <div class="col_12">
                                            <div class="form-group">
                                                <label>{{ 'coordinate.plural.value' | translate }}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row marges ligne_form">
                                        <div class="col_6 y_items_center">
                                            <app-core-google-places-location [fields]="getAddressLocationFields(getAddressControl(i))" (onSelection)="selectAddress(i)"></app-core-google-places-location>
                                        </div>
                                    </div>

                                    <div class="row marges ligne_form">
                                        <div class="col_12 col_md_6">

                                            <!-- Adresse -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="address" id="address" required="required">
                                                <label for="address">{{'form.user.fields.address.value' | translate}}</label>
                                                @if(getAddressControl(i).get('address').errors && (getAddressControl(i).get('address').dirty || getAddressControl(i).get('address').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(getAddressControl(i).get('address').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>

                                        <div class="col_12 col_md_6">

                                            <!-- Complément d'adresse -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="additionalAddress" id="additionalAddress">
                                                <label for="additionalAddress">{{'form.user.fields.additionalAddress.value' | translate}}</label>
                                                @if(getAddressControl(i).get('additionalAddress').errors && (getAddressControl(i).get('additionalAddress').dirty || getAddressControl(i).get('additionalAddress').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(getAddressControl(i).get('additionalAddress').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row marges ligne_form">
                                        <div class="col_12 col_md_6">

                                            <!-- Code postal -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="zipcode" id="zipcode" required="required">
                                                <label for="zipcode">{{'form.user.fields.zipcode.value' | translate}}</label>
                                                @if(getAddressControl(i).get('zipcode').errors && (getAddressControl(i).get('zipcode').dirty || getAddressControl(i).get('zipcode').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(getAddressControl(i).get('zipcode').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                            @if(getAddressControl(i).get('zipcode').errors.pattern) {
                                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                        <div class="col_12 col_md_6">

                                            <!-- Ville -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="city" id="city" required="required">
                                                <label for="city">{{'form.user.fields.city.value' | translate}}</label>
                                                @if(getAddressControl(i).get('city').errors && (getAddressControl(i).get('city').dirty || getAddressControl(i).get('city').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(getAddressControl(i).get('city').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row marges ligne_form">
                                        <div class="col_12 col_md_6">

                                            <!-- Région -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="region" id="region" required="required">
                                                <label for="region">{{'form.user.fields.region.value' | translate}}</label>
                                                @if(getAddressControl(i).get('region').errors && (getAddressControl(i).get('region').dirty || getAddressControl(i).get('city').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(getAddressControl(i).get('region').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>

                                        <div class="col_12 col_md_6">

                                            <!-- Pays -->

                                            <div class="form-group">
                                                <select class="form-control" id="country" formControlName="country" required="required">
                                                    @for((country of countries$ | async); track country) {
                                                        <option [value]="country.code">{{ translationService.getFallbackTranslation(country.translations).name }}</option>
                                                    }
                                                </select>
                                                <label class="required"
                                                       for="country">{{ 'form.user.fields.country.value' | translate }}</label>
                                                @if(getAddressControl(i).get('country').invalid && (getAddressControl(i).get('country').dirty || getAddressControl(i).get('country').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(getAddressControl(i).get('country').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </ng-container>

                        </ng-container>

                    </ng-container>

                </ng-container>

            </ng-template>

            @if(hasRole('ROLE_OFFER_CREATOR')) {

                <div class="ligne_form">

                    <div class="form_part">

                        <p class="title_part">{{ 'society.publication.status.value' | translate }}</p>

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <!-- Blocage du statut -->

                                <div class="form-group" formGroupName="information">
                                    <label>{{'society.information.publication.lock.action.value' | translate}}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="locked" class="form-control" id="lockedNo">
                                        <label for="lockedNo">{{'form.user.fields.no.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="locked" class="form-control" id="lockedYes">
                                        <label for="lockedYes">{{'form.user.fields.yes.value' | translate}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <!-- Publié / Dépublié -->

                                <div class="form-group" formGroupName="information">
                                    <label>{{'society.information.published.value' | translate}}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="enable" class="form-control" id="enableNo">
                                        <label for="enableNo">{{'form.user.fields.no.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="enable" class="form-control" id="enableYes">
                                        <label for="enableYes">{{'form.user.fields.yes.value' | translate}}</label>
                                    </div>
                                    @if(societyInformationForm.get('enable').errors && (societyInformationForm.get('enable').dirty || societyInformationForm.get('enable').touched)) {
                                        <mat-error style="padding: 0;margin-top: 12px;">
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('enable').errors.isValid) {
                                                    <div>{{ 'form.control.error.user.enable.configuration.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            }

            <div class="row marges ligne_form">

                <div class="form_part col_12">
                    <p class="title_part">{{ 'form.user.title.societyInformations.logo.value' | translate }}</p>
                </div>

                <div class="col_6">
                    <!-- Logo -->
                    <div class="form-group">
                        <label class="required">{{ 'file.add.action.logo.value' | translate }}</label>
                        <form-field-file [config]="societyLogoConfig" [form]="societyForm"></form-field-file>
                    </div>
                </div>
                <div class="col_6">
                    <!-- Logo PIM -->
                    <div class="form-group">
                        <label class="required">{{ 'file.add.action.logo.administration.value' | translate }}</label>
                        <form-field-file [config]="societyAdministrationLogoConfig" [form]="societyForm"></form-field-file>
                        @if(societyForm.get('administrationLogo').invalid) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(societyForm.get('administrationLogo').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

            @if(profileDisplayed) {

                <div class="row marges ligne_form">
                    <div class="form_part col_12">
                        <p class="title_part" style="margin-bottom: 0">{{ 'form.user.title.societyInformations.information.value' | translate }}</p>
                    </div>
                </div>

                @if(hasRole('ROLE_OFFER_CREATOR')) {
                    <ng-container formGroupName="information">

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="mat-tab-translations" [ngClass]="societyInformationTranslationBuilder.itemsControl|translationPanelValidationClass:['presentation']">

                                    <ng-container formArrayName="translations">

                                        <mat-tab-group [@.disabled]="true">

                                            @for (_ of societyInformationTranslationBuilder.itemsControl.controls; let it = $index; track it) {
                                                <div>

                                                    <mat-tab label="{{ societyInformationTranslationBuilder.getLocaleLabel(societyInformationTranslationBuilder.getItemControl(it).value.locale) | translate }}" [labelClass]="societyInformationTranslationBuilder.getItemControl(it)|translationTabValidationClass:['presentation']">

                                                        <ng-container [formGroupName]="societyInformationTranslationBuilder.indexAsString(it)">

                                                            <div class="row marges ligne_form">
                                                                <div class="col_12">
                                                                    <div class="form-group">
                                                                        <label>{{ 'presentation.value' | translate }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row marges ligne_form">
                                                                <div class="col_12">

                                                                    <!-- Présentation -->

                                                                    <div class="form-group">
                                                                        <app-ckeditor [form]="societyInformationTranslationBuilder.getItemControlByLocale(societyInformationTranslationBuilder.getItemControl(it).value.locale)" [config]="presentationEditorConfig" [ckeditorConfig]="ckeditorConfig"></app-ckeditor>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </ng-container>

                                                    </mat-tab>

                                                </div>
                                            }
                                        </mat-tab-group>

                                    </ng-container>

                                </div>

                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_6">

                                <!-- Langues parlées -->

                                <div class="form-group">
                                    <mat-select formControlName="spokenLanguages" multiple>
                                        @for(language of societySpokenLanguages; track language) {
                                            <mat-option [value]="language">{{ ('locale.' + language + '.value') | translate }}</mat-option>
                                        }
                                        <mat-option [value]="otherSpokenLanguagesIdentifier">{{ 'other.value' | translate }}</mat-option>
                                    </mat-select>
                                    <mat-label class="required">{{ 'language.plural.spoken.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('spokenLanguages').errors && (societyInformationForm.get('spokenLanguages').dirty || societyInformationForm.get('spokenLanguages').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('spokenLanguages').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                        @if(societyInformationForm.get('spokenLanguages').value.includes(otherSpokenLanguagesIdentifier)) {
                            <div class="row marges ligne_form">

                                <div class="col_12">

                                    <div class="mat-tab-translations" [ngClass]="societyInformationTranslationBuilder.itemsControl|translationPanelValidationClass:['spokenLanguages']">

                                        <ng-container formArrayName="translations">

                                            <mat-tab-group [@.disabled]="true">

                                                @for (_ of societyInformationTranslationBuilder.itemsControl.controls; let it = $index; track it) {
                                                    <div>

                                                        <mat-tab label="{{ societyInformationTranslationBuilder.getLocaleLabel(societyInformationTranslationBuilder.getItemControl(it).value.locale) | translate }}" [labelClass]="societyInformationTranslationBuilder.getItemControl(it)|translationTabValidationClass:['spokenLanguages']">

                                                            <ng-container [formGroupName]="societyInformationTranslationBuilder.indexAsString(it)">

                                                                <div class="row marges ligne_form">

                                                                    <div class="col_12">

                                                                        <!-- Langues parlées -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="spokenLanguages" id="translationSpokenLanguages">
                                                                             <label for="translationSpokenLanguages">{{ 'language.plural.other.value' | translate }}</label>
                                                                             @if(societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').invalid && (societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').dirty || societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').touched)) {
                                                                                 <mat-error>
                                                                                     <div class="invalid-feedback">
                                                                                         @if(societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').errors.isRequired) {
                                                                                             <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                         }
                                                                                     </div>
                                                                                 </mat-error>
                                                                             }
                                                                         </div>
                                                                     </div>
                                                                </div>

                                                            </ng-container>

                                                        </mat-tab>

                                                    </div>
                                                }
                                            </mat-tab-group>

                                        </ng-container>

                                    </div>

                                </div>

                            </div>
                        }

                        <div class="row marges ligne_form">
                            <div class="col_12">

                                <!-- Labellisé RSE -->

                                <div class="form-group">
                                    <label>{{'rse.labelled.value' | translate}}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="hasRseLabel" class="form-control" id="hasRseLabelNo">
                                        <label for="hasRseLabelNo">{{'form.user.fields.no.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="hasRseLabel" class="form-control" id="hasRseLabelYes">
                                        <label for="hasRseLabelYes">{{'form.user.fields.yes.value' | translate}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if(societyInformationForm.get('hasRseLabel').value) {
                            <div class="row marges ligne_form">

                                <div class="col_12">

                                    <div class="mat-tab-translations" [ngClass]="societyInformationTranslationBuilder.itemsControl|translationPanelValidationClass:['rseLabel']">

                                        <ng-container formArrayName="translations">

                                            <mat-tab-group [@.disabled]="true">

                                                @for (_ of societyInformationTranslationBuilder.itemsControl.controls; let it = $index; track it) {
                                                    <div>

                                                        <mat-tab label="{{ societyInformationTranslationBuilder.getLocaleLabel(societyInformationTranslationBuilder.getItemControl(it).value.locale) | translate }}" [labelClass]="societyInformationTranslationBuilder.getItemControl(it)|translationTabValidationClass:['rseLabel']">

                                                            <ng-container [formGroupName]="societyInformationTranslationBuilder.indexAsString(it)">

                                                                <div class="row marges ligne_form">

                                                                    <div class="col_12">

                                                                        <!-- Label RSE -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="rseLabel" id="rseLabel">
                                                                            <label for="rseLabel">{{ 'rseLabel.value' | translate }}</label>
                                                                            @if(societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').errors && (societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').dirty || societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').errors.isRequired) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </ng-container>

                                                        </mat-tab>

                                                    </div>
                                                }
                                            </mat-tab-group>

                                        </ng-container>

                                    </div>

                                </div>

                            </div>
                        }

                        <div class="row marges ligne_form" style="align-items: center;">

                            <div class="col_6">

                                <!-- Cibles clientèle -->

                                <div class="form-group">
                                    <mat-select multiple [compareWith]="compareById" formControlName="customerTypologies">
                                        @for(customerTypology of customerTypologies; track customerTypology) {
                                            <mat-option [value]="customerTypology">
                                                {{ translationService.getFallbackTranslation(customerTypology.translations).name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-label class="required">{{ 'customer.target.plural.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('customerTypologies').errors && (societyInformationForm.get('customerTypologies').dirty || societyInformationForm.get('customerTypologies').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('customerTypologies').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_6">

                                <!-- Destinations -->

                                <div class="form-group">

                                    <app-core-select-group [configuration]="regionSelectConfiguration" [sourceCallback]="regionSelectSourceCallback"></app-core-select-group>

                                    @if(societyInformationForm.get('regions').errors && (societyInformationForm.get('regions').dirty || societyInformationForm.get('regions').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('regions').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                        <div class="row marges ligne_form" style="align-items: center;">

                            <div class="col_6">

                                <!-- Types de séjours -->

                                <div class="form-group">
                                    <mat-select multiple [compareWith]="compareById" formControlName="types">
                                        @for(type of types; track type) {
                                            <mat-option [value]="type">
                                                {{ translationService.getFallbackTranslation(type.translations).label }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-label class="required">{{ 'stay.plural.type.plural.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('types').errors && (societyInformationForm.get('types').dirty || societyInformationForm.get('types').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('types').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_6">

                                <!-- Types d’offre -->

                                <div class="form-group">
                                    <mat-select multiple formControlName="durationTypes">
                                        @for(type of durationTypes; track type) {
                                            <mat-option [value]="type">
                                                {{ ('offer.type.' + type + '.value') | translate }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-label class="required">{{ 'offer.plural.type.plural.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('durationTypes').errors && (societyInformationForm.get('durationTypes').dirty || societyInformationForm.get('durationTypes').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('durationTypes').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                    </ng-container>
                }

                @if(hasRole('ROLE_PROVIDER')) {

                    <!-- Réseaux de prestataires -->

                    <div class="row marges ligne_form">

                        <div class="col_12">

                            <div class="form-group">
                                <label>{{ 'networkProvider.plural.value' | translate }}</label>
                                <br>
                                <span>{{ parsedNetworkProviders }}</span>
                            </div>
                        </div>
                    </div>

                }

                @if(society?.networkOfferCreators.length) {

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Réseaux de créateurs d'offres -->

                            <div class="form-group">
                                <label>{{ 'network.offerCreator.list.title.value' | translate }}</label>
                                <br>
                                <span>{{ parsedNetworkOfferCreatorNames }}</span>
                            </div>
                        </div>
                    </div>

                }

                <!-- Groupes d'utilisateur -->

                <div class="row marges ligne_form">

                    <div class="col_12">

                        <div class="form-group">
                            <label>{{ 'societyGroup.plural.value' | translate }}</label>
                            <br>
                            <span>{{ parsedSocietyGroups }}</span>
                        </div>
                    </div>
                </div>

            }

            <!-- Documents CGV -->

            @if(hasOneOfThisRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {
                <ng-container *ngTemplateOutlet="formTermsAndConditions"></ng-container>
            }
        </div>

    </ng-container>

</ng-template>

<!-- Données licence créateur d’offres -->

<ng-template #licence>
    <div class="ligne_form">
        @if(subscriptions.length && subscriptionsSociety.length) {
            <subscription-form [subscriptions]="subscriptions" [data]="subscriptionsSociety" [society]="society" [isDisabled]="true" [redirectionToSubscriptionViewEnabled]="false"></subscription-form>
        }
    </div>
</ng-template>

<!-- Données contact -->

<ng-template #contactInformations>

    <ng-container [formGroup]="form">

        <div formGroupName="society">

            <div formGroupName="admin">

                @if(hasOneOfThisRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_PROVIDER'])) {

                    <!-- Admin du compte -->

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'form.user.fields.admin.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" [(ngModel)]="isAccountAdmin" [ngModelOptions]="{standalone: true}" class="form-control" id="isAdminYes" (click)="patchSocietyAdmin(adminForm.get('society').value)">
                                    <label for="isAdminYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" [(ngModel)]="isAccountAdmin" [ngModelOptions]="{standalone: true}" class="form-control" id="isAdminNo" (click)="patchSocietyAdmin(null)">
                                    <label for="isAdminNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                }

                <div class="row marges ligne_form">
                    <div class="col_12">

                        <!-- Dernière connexion et nombre de connexion -->

                        <div class="form-group">
                            <label>{{ 'collaborator.connexion.history.value' | translate }}</label>
                            @if(society.admin.lastLoginAt !== null) {
                                <div>{{ 'user.lastLoginAt.value' | translate }} : {{society.admin.lastLoginAt | date: 'short'}}</div>
                            } @else {
                                <div>{{ 'user.lastLoginAt.value' | translate }} : {{'none' | translate}}</div>
                            }
                            <div>{{ 'user.nbrOfConnection.value' | translate }} : {{society.admin.nbrOfConnections}}</div>
                        </div>

                        <!-- Civilité -->

                        <div class="form-group">
                            <label>{{'form.user.fields.civility.title.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="1" formControlName="civility" class="form-control" id="civility-mister">
                                <label for="civility-mister">{{'form.user.fields.civility.mister.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="2" formControlName="civility" class="form-control" id="civility-madam">
                                <label for="civility-madam">{{'form.user.fields.civility.madam.value' | translate}}</label>
                            </div>

                            @if(adminForm.get('civility').errors && (adminForm.get('civility').dirty || adminForm.get('civility').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('civility').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>
                <div class="row marges ligne_form">
                    <div class="col_12 col_md_4">

                        <!-- Nom -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="lastName" id="lastName" required="required">
                            <label for="lastName">{{'form.user.fields.lastname.value' | translate}}</label>
                            @if(adminForm.get('lastName').errors && (adminForm.get('lastName').dirty || adminForm.get('lastName').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('lastName').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col_12 col_md_4">

                        <!-- Prénom -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="firstName" id="firstName" required="required">
                            <label for="firstName">{{'form.user.fields.firstname.value' | translate}}</label>
                            @if(adminForm.get('firstName').errors && (adminForm.get('firstName').dirty || adminForm.get('firstName').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('firstName').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col_12 col_md_4">

                        <!-- Email -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="email" id="emailContact" required="required">
                            <label for="emailContact">{{'form.user.fields.email.contact.value' | translate}}</label>
                            @if(adminForm.get('email').errors && (adminForm.get('email').dirty || adminForm.get('email').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('email').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(adminForm.get('email').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>
                <div class="row marges ligne_form">
                    <div class="col_12 col_md_4">

                        <!-- Téléphone fixe -->

                        <div class="form-group">

                            <app-core-intl-tel-input [formGroup]="adminForm" [controlName]="'switchboardPhone'" customPlaceholder="{{'form.user.fields.switchboardPhone.value' | translate}}"></app-core-intl-tel-input>

                            @if(adminForm.get('switchboardPhone').errors && (adminForm.get('switchboardPhone').dirty || adminForm.get('switchboardPhone').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('switchboardPhone').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(adminForm.get('switchboardPhone').errors.validatePhoneNumber) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col_12 col_md_4">

                        <!-- Ligne directe -->

                        <div class="form-group">

                            <app-core-intl-tel-input [formGroup]="adminForm" [controlName]="'directPhone'" customPlaceholder="{{'form.user.fields.directPhone.value' | translate}}"></app-core-intl-tel-input>

                            @if(adminForm.get('directPhone').errors && (adminForm.get('directPhone').dirty || adminForm.get('directPhone').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('directPhone').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(adminForm.get('directPhone').errors.validatePhoneNumber) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col_12 col_md_4">

                        <!-- Portable -->

                        <div class="form-group">

                            <app-core-intl-tel-input [formGroup]="adminForm" [controlName]="'cellphone'" customPlaceholder="{{'form.user.fields.cellphone.value' | translate}}"></app-core-intl-tel-input>

                            @if(adminForm.get('cellphone').errors && (adminForm.get('cellphone').dirty || adminForm.get('cellphone').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('cellphone').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(adminForm.get('cellphone').errors.validatePhoneNumber) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>
                <div class="row marges ligne_form">
                    <div class="col_12 col_md_4">
                        <div class="form-group">
                            <app-core-timezone-select [form]="adminForm" [required]="true"></app-core-timezone-select>
                        </div>
                    </div>

                    <div class="col_12 col_md_4">

                        <!-- Service -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="service" id="service">
                            <label for="service">{{'form.user.fields.service.value' | translate}}</label>
                            @if(adminForm.get('service').errors &&(adminForm.get('service').dirty || adminForm.get('service').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('service').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_4">

                        <!-- Locale -->

                        <div class="form-group">
                            <select class="form-control" id="adminLocale" formControlName="locale" required="required">
                                <option value=""></option>
                                @for((locale of locales$ | async); track locale) {
                                    <option [value]="locale.id">
                                        {{ locale.label | translate }}
                                    </option>
                                }
                            </select>
                            <label class="required" for="locale">{{ 'form.user.fields.locale.value' | translate }}</label>
                            @if(adminForm.get('locale').errors && (adminForm.get('locale').dirty || adminForm.get('locale').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('locale').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                </div>
                <div class="row marges ligne_form">
                    <div class="col_12">

                        <!-- Commentaire -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="comment" id="comment">
                            <label for="comment">{{'form.user.fields.comment.value' | translate}}</label>
                            @if(adminForm.get('comment').errors &&(adminForm.get('comment').dirty || adminForm.get('comment').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(adminForm.get('comment').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <ng-container *ngTemplateOutlet="resetPassword"></ng-container>

            </div>

        </div>

    </ng-container>

</ng-template>

<!-- Supression de l'utilisateur -->

<ng-template #deactivateAccount>

    @switch (true) {

        @case (hasRole('ROLE_OFFER_CREATOR') && hasRole('ROLE_OFFER_DISTRIBUTOR')) {

            <!-- Rôle Créateur d'offre & Distributeur d'offre -->

            <div>
                <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                    {{'subscription.form.delete.title.value' | translate }}
                </button>
            </div>
        }

        @case (hasRole('ROLE_OFFER_CREATOR') && !hasRole('ROLE_OFFER_DISTRIBUTOR')) {

            <!-- Rôle Créateur d'offre -->

            <div>
                <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                    {{'subscription.form.delete.title.value' | translate }}
                </button>
            </div>
        }

        @case (hasRole('ROLE_OFFER_DISTRIBUTOR') && !hasRole('ROLE_OFFER_CREATOR')) {

            <!-- Rôle Distributeur d'offre -->

            <div>
                <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                    {{'subscription.form.delete.title.value' | translate }}
                </button>
            </div>
        }

        @case (hasRole('ROLE_PROVIDER')) {

            <!-- Rôle Prestataire -->

            <div>
                <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                    {{'subscription.form.delete.title.value' | translate }}
                </button>
            </div>
        }

        @case (hasRole('ROLE_INSTITUTIONAL')) {

            <!-- Rôle Institutionnel -->

            <div>
                <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                    {{'subscription.form.delete.title.value' | translate }}
                </button>
            </div>
        }

        @case (hasRole('ROLE_FEDERATION')) {

            <!-- Rôle Fédération -->

            <div>
                <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                    {{'subscription.form.delete.title.value' | translate }}
                </button>
            </div>
        }
    }

</ng-template>

<!-- Renouvellement du mot de passe -->

<ng-template #resetPassword>

    <div class="row marges ligne_form">
        <div class="col_12">
            <button type="button" class="btn_cta" (click)="resetPasswordDialog()">
                {{ 'user.password.reset.action.value' | translate }}
            </button>
        </div>
    </div>

</ng-template>

<!-- Administration du compte distributeur -->

<ng-template #distributorAdministrationInformations>

    <ng-container [formGroup]="form">

        <!-- Gestion des commissions -->

        @if(isAvailableCommission) {

            <ng-container formGroupName="society">

                <div class="form_part">
                    <p class="title_part">{{ 'form.user.administration.title.commission.value' | translate }}</p>
                </div>

                <ng-container formGroupName="commission">

                    <div class="row marges ligne_form">

                        <div class="col_12">
                            <div class="form-group">
                                <label>{{ 'society.commission.enable.title.value' | translate }}</label>
                            </div>
                        </div>

                        <div class="col_12">
                            <div class="form-group">
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="enable" class="form-control" id="societyCommissionEnableNo">
                                    <label for="societyCommissionEnableNo">{{'no.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="enable" class="form-control" id="societyCommissionEnableYes">
                                    <label for="societyCommissionEnableYes">{{'yes.value' | translate}}</label>
                                </div>
                                @if(societyForm.get('commission').get('enable').value) {
                                    <div class="form-group col_content y_items_center" style="margin-top: 12px">
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'form.user.fields.commission.type.info.value' | translate }}</span>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>

                    @if(societyForm.get('commission').get('enable').value) {

                        <div class="col_12 row marges ligne_form">

                            <div class="col_4">
                                <div class="form-group">
                                    <input type="text" placeholder=" " class="form-control" formControlName="individualStay" id="commissionIndividualStay">
                                    <label for="commissionIndividualStay" class="required">{{ 'form.user.fields.commission.individualStay.value' | translate }} :</label>
                                    @if(societyForm.get('commission').get('individualStay').errors && (societyForm.get('commission').get('individualStay').dirty || societyForm.get('commission').get('individualStay').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyForm.get('commission').get('individualStay').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(societyForm.get('commission').get('individualStay').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>

                            <div class="col_4">
                                <div class="form-group">
                                    <input type="text" placeholder=" " class="form-control" formControlName="individualDay" id="commissionIndividualDay">
                                    <label for="commissionIndividualDay" class="required">{{ 'form.user.fields.commission.individualDay.value' | translate }} :</label>
                                    @if(societyForm.get('commission').get('individualDay').errors && (societyForm.get('commission').get('individualDay').dirty || societyForm.get('commission').get('individualDay').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyForm.get('commission').get('individualDay').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(societyForm.get('commission').get('individualDay').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>

                        </div>

                        <div class="col_12 row marges ligne_form">

                            <div class="col_4">
                                <div class="form-group">
                                    <input type="text" placeholder=" " class="form-control" formControlName="groupStay" id="commissionGroupStay">
                                    <label for="commissionGroupStay" class="required">{{ 'form.user.fields.commission.groupStay.value' | translate }} :</label>
                                    @if(societyForm.get('commission').get('groupStay').errors && (societyForm.get('commission').get('groupStay').dirty || societyForm.get('commission').get('groupStay').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyForm.get('commission').get('groupStay').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(societyForm.get('commission').get('groupStay').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>

                            <div class="col_4">
                                <div class="form-group">
                                    <input type="text" placeholder=" " class="form-control" formControlName="groupDay" id="commissionGroupDay">
                                    <label for="commissionGroupDay" class="required">{{ 'form.user.fields.commission.groupDay.value' | translate }} :</label>
                                    @if(societyForm.get('commission').get('groupDay').errors && (societyForm.get('commission').get('groupDay').dirty || societyForm.get('commission').get('groupDay').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyForm.get('commission').get('groupDay').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(societyForm.get('commission').get('groupDay').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{ 'form.user.fields.commission.incomingPayment.value' | translate }}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="incomingPayment" class="form-control" id="incomingPaymentYes">
                                        <label for="incomingPaymentYes">{{'form.user.fields.yes.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="incomingPayment" class="form-control" id="incomingPaymentNo">
                                        <label for="incomingPaymentNo">{{'form.user.fields.no.value' | translate}}</label>
                                    </div>
                                    <div class="form-group col_content y_items_center">
                                <span class="message-help">
                                    <mat-icon class="tooltip_icon">info</mat-icon>
                                    {{ ('form.user.fields.commission.incomingPayment.' + (societyForm.get('commission').get('incomingPayment').value ? 'yes' : 'no') + '.info.value') | translate }}
                                </span>
                                    </div>
                                </div>
                            </div>

                        </div>

                    }

                </ng-container>

            </ng-container>
        }

        <ng-container formGroupName="society">

            <div class="row marges ligne_form">

                <div class="form_part col_12">
                    <p class="title_part">{{ 'form.user.administration.title.internalCommission.value' | translate }}</p>
                </div>

                <div class="col_12">
                    <div class="form-group">
                        <label>{{ 'form.user.fields.society.isCommissionPaymentEnable.value' | translate }}</label>
                        <div class="radio">
                            <input type="radio" [value]="true" formControlName="isCommissionPaymentEnable" class="form-control" id="isCommissionPaymentEnableYes">
                            <label for="isCommissionPaymentEnableYes">{{'form.user.fields.yes.value' | translate}}</label>
                        </div>
                        <div class="radio">
                            <input type="radio" [value]="false" formControlName="isCommissionPaymentEnable" class="form-control" id="isCommissionPaymentEnableNo">
                            <label for="isCommissionPaymentEnableNo">{{'form.user.fields.no.value' | translate}}</label>
                        </div>
                        <div class="form-group col_content y_items_center">
                            <span class="message-help">
                                <mat-icon class="tooltip_icon">info</mat-icon>
                                {{ ('form.user.fields.society.isCommissionPaymentEnable.' + (societyForm.get('isCommissionPaymentEnable').value ? 'yes' : 'no') + '.info.value') | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>

        <div class="row marges ligne_form">

            <div class="form_part col_12">
                <p class="title_part">{{ 'form.user.administration.title.channel.value' | translate }}</p>
            </div>

            <ng-container formGroupName="society">

                <ng-container formGroupName="channelConfiguration">

                    <!-- Autoriser l'utilisateur à utiliser l'API -->

                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'form.user.fields.hasAccessAPI.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="hasAccessAPI" class="form-control" id="hasAccessAPIYes">
                                <label for="hasAccessAPIYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="hasAccessAPI" class="form-control" id="hasAccessAPINo">
                                <label for="hasAccessAPINo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>

                </ng-container>

            </ng-container>
        </div>

        @if(!!societyChannelConfigurationControl.get('hasAccessAPI').value) {

            <div class="row marges ligne_form">

                <ng-container formGroupName="society">

                    <ng-container formGroupName="channelConfiguration">

                        <!-- Autoriser les paiements externes -->

                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'form.user.fields.allowExternalPayment.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="allowExternalPayment" class="form-control" id="allowExternalPaymentYes">
                                    <label for="allowExternalPaymentYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="allowExternalPayment" class="form-control" id="allowExternalPaymentNo">
                                    <label for="allowExternalPaymentNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                @if(societyChannelConfigurationControl.get('allowExternalPayment').value) {
                                    <div class="form-group col_content y_items_center">
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'channel.marketing.configuration.api.externalPayment.help.value' | translate }}</span>
                                    </div>
                                }
                            </div>
                        </div>

                    </ng-container>

                </ng-container>

            </div>

        }

        <ng-container formGroupName="administration">

            <!-- Création d’iframe autorisée par l’utilisateur -->

            <div class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <label>{{'form.user.fields.iframe.creation.enabled.value' | translate}}</label>
                        <div class="radio">
                            <input type="radio" [value]="true" formControlName="iframeCreation" class="form-control" id="iframeCreationYes">
                            <label for="iframeCreationYes">{{'form.user.fields.yes.value' | translate}}</label>
                        </div>
                        <div class="radio">
                            <input type="radio" [value]="false" formControlName="iframeCreation" class="form-control" id="iframeCreationNo">
                            <label for="iframeCreationNo">{{'form.user.fields.no.value' | translate}}</label>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>

        @if(administrationForm.get('iframeCreation').value) {

            <ng-container formGroupName="society">

                <ng-container formGroupName="channelConfiguration">

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <div class="checkbox min-size">
                                    <input type="checkbox" id="hasAccessCreateChannelGiftVoucher" formControlName="hasAccessCreateChannelGiftVoucher">
                                    <label for="hasAccessCreateChannelGiftVoucher">{{ 'channel.configuration.giftVoucher.value' | translate }}</label>
                                </div>
                                <div class="checkbox min-size">
                                    <input type="checkbox" id="hasAccessCreateChannelOnlineSale" formControlName="hasAccessCreateChannelOnlineSale">
                                    <label for="hasAccessCreateChannelOnlineSale">{{ 'channel.configuration.onlineSale.value' | translate }}</label>
                                </div>
                                <div class="checkbox min-size">
                                    <input type="checkbox" id="hasAccessCreateChannelBooking" formControlName="hasAccessCreateChannelBooking">
                                    <label for="hasAccessCreateChannelBooking">{{ 'channel.configuration.booking.value' | translate }}</label>
                                </div>
                                <div class="checkbox min-size">
                                    <input type="checkbox" id="hasAccessCreateChannelRequest" formControlName="hasAccessCreateChannelRequest">
                                    <label for="hasAccessCreateChannelRequest">{{ 'channel.configuration.request.value' | translate }}</label>
                                </div>
                                <div class="checkbox min-size">
                                    <input type="checkbox" id="hasAccessCreateChannelShowcase" formControlName="hasAccessCreateChannelShowcase">
                                    <label for="hasAccessCreateChannelShowcase">{{ 'channel.configuration.showcase.value' | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if(societyChannelConfigurationControl.get('hasAccessCreateChannelShowcase').value) {

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="form-group">
                                    <label>{{'channel.showcase.modale.enable.value' | translate}}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="enableModale" class="form-control" id="enableModaleYes">
                                        <label for="enableModaleYes">{{'form.user.fields.yes.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="enableModale" class="form-control" id="enableModaleNo">
                                        <label for="enableModaleNo">{{'form.user.fields.no.value' | translate}}</label>
                                    </div>
                                </div>

                            </div>

                        </div>

                    }

                </ng-container>

                <ng-container formGroupName="channelConfiguration">

                    @if(societyChannelConfigurationControl.get('hasAccessCreateChannelShowcase').value && societyChannelConfigurationControl.get('enableModale').value) {

                        @if(societyChannelConfigurationTranslationBuilder.itemsControl.length) {
                            <div class="row marges ligne_form">

                                <div class="col_12">

                                    <div class="mat-tab-translations" [ngClass]="societyChannelConfigurationTranslationBuilder.itemsControl|translationPanelValidationClass:['buttonContent', 'modaleTitle', 'modaleContent', 'redirectionButtonContent', 'redirectionButtonLink']">

                                        <ng-container formArrayName="translations">

                                            <mat-tab-group [@.disabled]="true">

                                                @for (_ of societyChannelConfigurationTranslationBuilder.itemsControl.controls; let it = $index; track it) {
                                                    <div>

                                                        <mat-tab label="{{societyChannelConfigurationTranslationBuilder.getLocaleLabel(societyChannelConfigurationTranslationBuilder.getItemControl(it).value.locale) | translate }}" [labelClass]="societyChannelConfigurationTranslationBuilder.getItemControl(it)|translationTabValidationClass:['buttonContent', 'modaleTitle', 'modaleContent', 'redirectionButtonContent', 'redirectionButtonLink']">

                                                            <ng-container [formGroupName]="societyChannelConfigurationTranslationBuilder.indexAsString(it)">

                                                                <div class="row marges ligne_form">

                                                                    <div class="col_6">

                                                                        <!-- Texte du bouton offre -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="buttonContent" id="{{it}}-buttonContent">
                                                                            <label class="required" for="{{it}}-buttonContent">{{ 'channel.showcase.buttonContent.value' | translate }}</label>
                                                                            @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('buttonContent').errors && (societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('buttonContent').dirty || societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('buttonContent').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('buttonContent').errors.isRequired) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    <div class="col_6">

                                                                        <!-- Titre modale -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="modaleTitle" id="{{it}}-modaleTitle">
                                                                            <label class="required" for="{{it}}-modaleTitle">{{ 'channel.showcase.modaleTitle.value' | translate }}</label>
                                                                            @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('modaleTitle').errors && (societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('modaleTitle').dirty || societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('modaleTitle').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('modaleTitle').errors.isRequired) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="row marges ligne_form">
                                                                    <div class="col_12">

                                                                        <!-- Contenu modale -->

                                                                        <div class="form-group">
                                                                            <label>{{ 'channel.showcase.modaleContent.value' | translate }}</label>
                                                                            <app-ckeditor [form]="societyChannelConfigurationTranslationBuilder.getItemControlByLocale(societyChannelConfigurationTranslationBuilder.getItemControl(it).value.locale)" [config]="societyChannelConfigurationModaleContentEditorConfig" [ckeditorConfig]="societyChannelConfigurationModaleContentCkeditorConfig"></app-ckeditor>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="row marges ligne_form">

                                                                    <div class="col_6">

                                                                        <!-- Texte du bouton modale -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="redirectionButtonContent" id="{{it}}-redirectionButtonContent">
                                                                            <label for="{{it}}-redirectionButtonContent" [ngClass]="{ required: societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonLink').value?.length > 0 }">{{ 'channel.showcase.redirectionButtonContent.value' | translate }}</label>
                                                                            @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonContent').errors && (societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonContent').dirty || societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonContent').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonContent').errors.isRequired) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    <div class="col_6">

                                                                        <!-- Lien de redirection -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="redirectionButtonLink" id="{{it}}-redirectionButtonLink">
                                                                            <label for="{{it}}-redirectionButtonLink" [ngClass]="{ required: societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonContent').value?.length > 0 }">{{ 'channel.showcase.redirectionButtonLink.value' | translate }}</label>
                                                                            @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonLink').errors && (societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonLink').dirty || societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonLink').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(societyChannelConfigurationTranslationBuilder.itemsControl.at(it).get('redirectionButtonLink').errors.isRequired) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </ng-container>

                                                        </mat-tab>

                                                    </div>
                                                }
                                            </mat-tab-group>

                                        </ng-container>

                                    </div>

                                </div>

                            </div>
                        }

                    }

                </ng-container>

            </ng-container>

        }

        <ng-container formGroupName="society">

            <div class="ligne_form">

                <div class="form_part col_12">
                    <p class="title_part">{{ 'form.user.administration.title.accessRestriction.value' | translate }}</p>
                </div>

            </div>

            <!-- Création d'offres Orchestra -->

            @if(hasRole('ROLE_OFFER_CREATOR')) {

                <ng-container formGroupName="offerConfiguration">

                    <div class="row marges ligne_form">

                        <div class="col_12">
                            <div class="form-group">
                                <label>{{ 'form.user.fields.offerConfiguration.orchestra.value' | translate }}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="allowOrchestra" class="form-control" id="allowOrchestraYes">
                                    <label for="allowOrchestraYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="allowOrchestra" class="form-control" id="allowOrchestraNo">
                                    <label for="allowOrchestraNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                            </div>
                        </div>

                    </div>

                </ng-container>

            }

            <!-- Restriction sur les réseaux de prestataires -->

            <div class="row marges ligne_form">
                <div class="col_4">
                    <div class="form-group">
                        <label>{{ 'form.user.fields.networkProvider.restriction.value' | translate }}</label>
                        <div class="radio">
                            <input type="radio" [value]="true" formControlName="hasRestrictedNetworkProvider" class="form-control" id="hasRestrictedNetworkProviderYes">
                            <label for="hasRestrictedNetworkProviderYes">{{'form.user.fields.yes.value' | translate}}</label>
                        </div>
                        <div class="radio">
                            <input type="radio" [value]="false" formControlName="hasRestrictedNetworkProvider" class="form-control" id="hasRestrictedNetworkProviderNo">
                            <label for="hasRestrictedNetworkProviderNo">{{'form.user.fields.no.value' | translate}}</label>
                        </div>
                    </div>

                </div>

                @if(societyForm.get('hasRestrictedNetworkProvider').value) {
                    <div class="col_8">
                        <div class="form-group">

                            <mat-select formControlName="restrictedNetworkProviders" [multiple]="true">

                                @for(group of restrictedNetworkProviders; track group) {
                                    <mat-optgroup [label]="group.name" [ngClass]="['canCheckGroup']">

                                        <input type="checkbox" class="mat-option-pseudo-checkbox mat-pseudo-checkbox" (click)="handleGroupNetworkProviderSelection(group.choices, $event)" #restrictedGroupNetworkProviderOptionCheckbox />

                                        <span class="container_checkbox"></span>

                                        @for(choice of group.choices; track choice) {
                                            <mat-option [value]="choice.id" (onSelectionChange)="handleNetworkProviderSelection(restrictedGroupNetworkProviderOptionCheckbox, group.choices, $event)">
                                                {{choice.name}}
                                            </mat-option>
                                        }

                                    </mat-optgroup>
                                }

                            </mat-select>
                            <mat-label>{{ 'form.user.fields.networkProvider.restriction.selection.action.value' | translate }}</mat-label>
                        </div>
                    </div>
                }
            </div>

        </ng-container>

        <!-- Restriction d’accès aux créateurs d’offres -->

        @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {
            <div class="row marges ligne_form">

                <ng-container formGroupName="administration">

                    <div class="col_4">
                        <div class="form-group">
                            <label>{{'form.user.fields.offer.restriction.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="offerRestriction" class="form-control" id="offerRestrictionYes">
                                <label for="offerRestrictionYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="offerRestriction" class="form-control" id="offerRestrictionNo">
                                <label for="offerRestrictionNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>

                    </div>

                </ng-container>

                <!-- Liste des créateurs d'offre -->

                @if(administrationForm.get('offerRestriction').value) {
                    <ng-container formGroupName="society">
                        <div class="col_8">
                            <div class="form-group">
                                <mat-select formControlName="restrictedOfferCreators" multiple>
                                    @for((society of offerCreatorSocieties$ | async); track society) {
                                        <mat-option [value]="society.id">
                                            {{ society.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                                <mat-label>{{ 'offerCreator.select.multiple.action.value' | translate }}</mat-label>
                            </div>
                        </div>
                    </ng-container>
                }
            </div>
        }


        <ng-container formGroupName="society">

            <!-- Restriction sur les réseaux de créateurs d'offres -->

            @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {
                <div class="row marges ligne_form">

                    <div class="col_4">
                        <div class="form-group">
                            <label>{{ 'form.user.fields.networkOfferCreator.restriction.value' | translate }}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="hasRestrictedNetworkOfferCreator" class="form-control" id="hasRestrictedNetworkOfferCreatorYes">
                                <label for="hasRestrictedNetworkOfferCreatorYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="hasRestrictedNetworkOfferCreator" class="form-control" id="hasRestrictedNetworkOfferCreatorNo">
                                <label for="hasRestrictedNetworkOfferCreatorNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>

                    </div>

                    @if(societyForm.get('hasRestrictedNetworkOfferCreator').value) {
                        <div class="col_8">
                            <div class="form-group">

                                <mat-select formControlName="restrictedNetworkOfferCreators" [multiple]="true">

                                    @for((network of restrictedNetworkOfferCreators$ | async); track network) {
                                        <mat-option [value]="network.id">
                                            {{ network.name }}
                                        </mat-option>
                                    }

                                </mat-select>

                                <mat-label>{{ 'form.user.fields.networkOfferCreator.restriction.selection.action.value' | translate }}</mat-label>

                            </div>
                        </div>
                    }
                </div>
            }

            @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {
                <div class="row marges ligne_form">

                    @if(networkOfferCreatorMarketplacePreference.length) {
                        <div class="col_12">
                            <div class="form-group">
                                <span>{{ 'form.user.fields.networkOfferCreator.marketplacePreference.value' | translate }} {{formattedNetworkOfferCreatorMarketplacePreference}}</span>
                            </div>
                        </div>
                    }

                </div>
            }

        </ng-container>

        <ng-container formGroupName="society">

            <!-- Accès aux offres soumises à licence -->

            @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {
                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'form.user.fields.offer.licence.access.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="hasAccessPublishedOffer" class="form-control" id="hasAccessPublishedOfferYes">
                                <label for="hasAccessPublishedOfferYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="hasAccessPublishedOffer" class="form-control" id="hasAccessPublishedOfferNo">
                                <label for="hasAccessPublishedOfferNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Accès aux offres en publication restreinte -->

            @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {
                <div class="row marges ligne_form">

                    <div class="col_4">
                        <div class="form-group">
                            <label>{{'form.user.fields.offer.publication.restricted.access.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="hasAccessRestrictedOffer" class="form-control" id="hasAccessRestrictedOfferYes">
                                <label for="hasAccessRestrictedOfferYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="hasAccessRestrictedOffer" class="form-control" id="hasAccessRestrictedOfferNo">
                                <label for="hasAccessRestrictedOfferNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>

                    <!-- Quota d'offre restreinte -->

                    @if(societyForm.get('hasAccessRestrictedOffer').value && hasOneOfThisRoles(['ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {
                        <div class="col_4">
                            <div class="form-group">
                                <input type="number" placeholder=" " class="form-control" formControlName="restrictedOfferQuota" id="restrictedOfferQuota">
                                <label>{{ 'form.user.fields.offer.publication.restricted.quota.value' | translate }} :</label>
                                @if(societyForm.get('restrictedOfferQuota').errors && (societyForm.get('restrictedOfferQuota').dirty || societyForm.get('quota').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyForm.get('restrictedOfferQuota').errors.isRequired) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(societyForm.get('restrictedOfferQuota').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    }

                </div>
            }

        </ng-container>

        @if(!hasRole('ROLE_PROVIDER')) {

            <div class="ligne_form">

                <div class="form_part col_12">
                    <p class="title_part">{{ 'article.plural.value' | translate }}</p>
                </div>

            </div>

            <!-- Accès aux publications -->

            <div class="row marges ligne_form">

                <div formGroupName="administration" [ngClass]="{ 'col_4': administrationForm.get('articleCreation').value, 'col_12': !administrationForm.get('articleCreation').value }">
                    <div class="form-group">
                        <label>{{ 'form.user.fields.article.creation.access.value' | translate }}</label>
                        <div class="radio">
                            <input type="radio" [value]="true" formControlName="articleCreation" class="form-control" id="articleCreationYes">
                            <label for="articleCreationYes">{{ 'form.user.fields.yes.value' | translate }}</label>
                        </div>
                        <div class="radio">
                            <input type="radio" [value]="false" formControlName="articleCreation" class="form-control" id="articleCreationNo">
                            <label for="articleCreationNo">{{ 'form.user.fields.no.value' | translate }}</label>
                        </div>
                        @if(!administrationForm.get('articleCreation').value) {
                            <div class="form-group col_content y_items_center">
                                <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>
                                    {{ 'form.user.fields.article.creation.access.no.info.value' | translate }}
                                </span>
                            </div>
                        }
                    </div>
                </div>

                <!-- Quota de publication -->

                @if(administrationForm.get('articleCreation').value) {
                    <ng-container formGroupName="society">

                        <div class="col_4">
                            <div class="form-group">
                                <input type="number" placeholder=" " class="form-control" formControlName="articleQuota" id="articleQuota">
                                <label>{{ 'quota.value' | translate }} :</label>
                                @if(societyForm.get('articleQuota').errors && (societyForm.get('articleQuota').dirty || societyForm.get('articleQuota').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyForm.get('articleQuota').errors.isRequired) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(societyForm.get('articleQuota').errors.invalidConfiguration) {
                                                <div>{{ 'article.quota.configuration.invalid.value' | translate:{ count: society?.articleQuota } }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                        <div class="col_4">

                            <!-- Date de dépublication -->

                            <app-input-date [form]="societyForm" [config]="revokedArticleAccessDateConfig"></app-input-date>

                        </div>
                    </ng-container>
                }

            </div>

        }

        @if(hasRole('ROLE_OFFER_DISTRIBUTOR')) {

            <div class="ligne_form">

                <div class="form_part col_12">
                    <p class="title_part">{{ 'tender.plural.value' | translate }}</p>
                </div>

            </div>

            <!-- Création d'appels d'offres autorisée par l’utilisateur -->

            <div formGroupName="administration" class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <label>{{'form.user.fields.tender.creation.enabled.value' | translate}}</label>
                        <div class="radio">
                            <input type="radio" [value]="true" formControlName="tenderCreation" class="form-control" id="tenderCreationYes">
                            <label for="tenderCreationYes">{{'form.user.fields.yes.value' | translate}}</label>
                        </div>
                        <div class="radio">
                            <input type="radio" [value]="false" formControlName="tenderCreation" class="form-control" id="tenderCreationNo">
                            <label for="tenderCreationNo">{{'form.user.fields.no.value' | translate}}</label>
                        </div>
                    </div>
                </div>
            </div>

        }

    </ng-container>

</ng-template>

<!-- Conditions générales de vente -->

<ng-template #formTermsAndConditions>

    <div class="row marges ligne_form">
        <div class="form_part col_12">
            <p class="title_part">{{ 'form.user.title.societyInformations.termsAndConditions.value' | translate }}</p>
        </div>
        <div class="col_12">
            <div class="form-group">
                <label>{{ 'form.user.fields.cgv.title.value' | translate }}</label>
            </div>
        </div>
    </div>

    <div class="row marges ligne_form">
        <div class="col_12">
            <app-terms-and-conditions [parentTermsAndConditions]="form"></app-terms-and-conditions>
        </div>
    </div>

</ng-template>

<!-- Représentant légal -->

<ng-template #legalRepresentative>

    <ng-container [formGroup]="form">

        <ng-container formGroupName="society">

            <div formGroupName="legalRepresentative">

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <!-- Civilité -->
                        <div class="form-group">
                            <label>{{'form.user.fields.civility.title.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="1" formControlName="civility" class="form-control" id="legalRepresentative-civility-mister">
                                <label for="legalRepresentative-civility-mister">{{'form.user.fields.civility.mister.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="2" formControlName="civility" class="form-control" id="legalRepresentative-civility-madam">
                                <label for="legalRepresentative-civility-madam">{{'form.user.fields.civility.madam.value' | translate}}</label>
                            </div>

                            @if(societyLegalRepresentativeControl.get('civility').errors && (societyLegalRepresentativeControl.get('civility').dirty || societyLegalRepresentativeControl.get('civility').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('civility').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_4">

                        <!-- Nom -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="lastName" id="legalRepresentativeLastName" required="required">
                            <label for="legalRepresentativeLastName">{{'form.user.fields.lastname.value' | translate}}</label>
                            @if(societyLegalRepresentativeControl.get('lastName').errors && (societyLegalRepresentativeControl.get('lastName').dirty || societyLegalRepresentativeControl.get('lastName').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('lastName').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col_12 col_md_4">

                        <!-- Prénom -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="firstName" id="legalRepresentativeFirstName" required="required">
                            <label for="legalRepresentativeFirstName">{{'form.user.fields.firstname.value' | translate}}</label>
                            @if(societyLegalRepresentativeControl.get('firstName').errors && (societyLegalRepresentativeControl.get('firstName').dirty || societyLegalRepresentativeControl.get('firstName').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('firstName').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_4">

                        <!-- Email -->

                        <div class="form-group">

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="email" id="legalRepresentativeEmail">
                                <label class="required" for="legalRepresentativeEmail">{{'user.email.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('email').errors && (societyLegalRepresentativeControl.get('email').dirty || societyLegalRepresentativeControl.get('email').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('email').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(societyLegalRepresentativeControl.get('email').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>

                        </div>
                    </div>

                </div>

                <div class="row marges ligne_form">

                    <div class="col_12 col_md_4">

                        <!-- Téléphone -->

                        <div class="form-group">

                            <app-core-intl-tel-input [formGroup]="societyLegalRepresentativeControl" [controlName]="'phone'" [required]="true" customPlaceholder="{{'form.user.fields.legalRepresentative.phone.value' | translate}}"></app-core-intl-tel-input>

                            @if(societyLegalRepresentativeControl.get('phone').errors && (societyLegalRepresentativeControl.get('phone').dirty || societyLegalRepresentativeControl.get('phone').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('phone').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(societyLegalRepresentativeControl.get('phone').errors.validatePhoneNumber) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_4">

                        <!-- Nationalité -->

                        <div class="form-group">
                            <select  class="form-control" id="legalRepresentativeNationality" formControlName="nationality" required="required">
                                @for((country of countries$ | async); track country) {
                                    <option [value]="country.code">
                                        {{ translationService.getFallbackTranslation(country.translations).name }}
                                    </option>
                                }
                            </select>
                            <label class="required" for="legalRepresentativeNationality">{{ 'form.user.fields.nationality.value' | translate }}</label>
                            @if(societyLegalRepresentativeControl.get('nationality').invalid && (societyLegalRepresentativeControl.get('nationality').dirty || societyLegalRepresentativeControl.get('nationality').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('nationality').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_4">

                        <!-- Date de naissance -->

                        <app-input-date [form]="societyLegalRepresentativeControl" [config]="birthDayConfig"></app-input-date>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_6 y_items_center">
                        <app-core-google-places-location [fields]="getAddressLocationFields(societyLegalRepresentativeControl)"></app-core-google-places-location>
                    </div>

                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Adresse -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="address" id="legalRepresentativeAddress" required="required">
                            <label for="legalRepresentativeAddress">{{'form.user.fields.address.value' | translate}}</label>
                            @if(societyLegalRepresentativeControl.get('address').errors && (societyLegalRepresentativeControl.get('address').dirty || societyLegalRepresentativeControl.get('address').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('address').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_6">

                        <!-- Complément d'adresse -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="additionalAddress" id="legalRepresentativeAdditionalAddress">
                            <label for="legalRepresentativeAdditionalAddress">{{'form.user.fields.additionalAddress.value' | translate}}</label>
                            @if(societyLegalRepresentativeControl.get('additionalAddress').errors && (societyLegalRepresentativeControl.get('additionalAddress').dirty || societyLegalRepresentativeControl.get('additionalAddress').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('additionalAddress').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Code postal -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="zipcode" id="legalRepresentativeZipcode" required="required">
                            <label for="legalRepresentativeZipcode">{{'form.user.fields.zipcode.value' | translate}}</label>
                            @if(societyLegalRepresentativeControl.get('zipcode').errors && (societyLegalRepresentativeControl.get('zipcode').dirty || societyLegalRepresentativeControl.get('zipcode').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('zipcode').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(societyLegalRepresentativeControl.get('zipcode').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col_12 col_md_6">

                        <!-- Ville -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="city" id="legalRepresentativeCity" required="required">
                            <label for="legalRepresentativeCity">{{'form.user.fields.city.value' | translate}}</label>
                            @if(societyLegalRepresentativeControl.get('city').errors && (societyLegalRepresentativeControl.get('city').dirty || societyLegalRepresentativeControl.get('city').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('city').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Région -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="region" id="legalRepresentativeRegion" required="required">
                            <label for="legalRepresentativeRegion">{{'form.user.fields.region.value' | translate}}</label>
                            @if(societyLegalRepresentativeControl.get('region').errors && (societyLegalRepresentativeControl.get('region').dirty || societyLegalRepresentativeControl.get('region').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('region').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_6">

                        <!-- Pays -->

                        <div class="form-group">
                            <select  class="form-control" id="legalRepresentativeCountry" formControlName="country" required="required">
                                @for((country of countries$ | async); track country) {
                                    <option [value]="country.code">
                                        {{ translationService.getFallbackTranslation(country.translations).name }}
                                    </option>
                                }
                            </select>
                            <label class="required" for="legalRepresentativeCountry">{{ 'form.user.fields.country.value' | translate }}</label>
                            @if(societyLegalRepresentativeControl.get('country').invalid && (societyLegalRepresentativeControl.get('country').dirty || societyLegalRepresentativeControl.get('country').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyLegalRepresentativeControl.get('country').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

    </ng-container>

</ng-template>

<ng-template #offerPermanentOptions>

    @let offerPermanentOptions = (offerPermanentOptions$ | async);
    @if (offerPermanentOptions) {

        @if(offerPermanentOptions.length) {

            @if(hasRole('ROLE_OFFER_CREATOR')) {
                <div class="ligne_form">
                    <div class="form-group">
                        <div class="row marges">
                            <div class="col y_items_center">
                                <p class="read">
                                    <strong>{{ 'form.user.title.permanentOptions.countPersonalOffers.value' | translate: { count: society.countOfferWithPermanentOptions } }}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            }

            @if(hasRole('ROLE_OFFER_DISTRIBUTOR')) {
                <div class="ligne_form">
                    <div class="form-group">
                        <div class="row marges">
                            <div class="col y_items_center">
                                <p class="read">
                                    <strong>{{ 'form.user.title.permanentOptions.countCatalogOffers.value' | translate: { count: society.countOfferCatalogWithPermanentOptions } }}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div class="ligne_form">
                <div class="form-group">
                    <div class="row marges">
                        <div class="col y_items_center">
                            <p class="read">
                                <strong>{{ 'form.user.title.permanentOptions.value' | translate }}</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ligne_form row marges">

                <div class="col_12">

                    <div class="form-group">

                        <div class="row marges">

                            @for(offerPermanentOption of offerPermanentOptions; track offerPermanentOption) {
                                <div class="col_4 y_content_start">

                                    <div class="read_composition_option col_12">

                                        <p class="read">
                                            <strong>{{ 'offer.permanentOption.name.value' | translate }} : </strong>
                                            {{ translationService.getFallbackTranslation(offerPermanentOption.translations).title }}
                                        </p>

                                        <p class="read">
                                            <strong>{{ 'offer.permanentOption.reference.value' | translate }} : </strong>
                                            {{ offerPermanentOption.reference }}
                                        </p>

                                        @if(offerPermanentOption.providerName) {
                                            <p class="read">
                                                <strong>{{ 'offer.permanentOption.providerName.value' | translate }} : </strong>
                                                {{ offerPermanentOption.providerName }}
                                            </p>
                                        }
                                    </div>

                                </div>
                            }

                        </div>

                    </div>

                </div>

            </div>

        }

        @if(!offerPermanentOptions.length) {
            <div class="page_title">
                <div class="subscription_information">
                    <p [innerHTML]="'form.user.title.permanentOptions.noResult.value' | translate"></p>
                </div>
            </div>
        }

    }

</ng-template>

<ng-template #services>

    <div class="ligne_form">
        <div class="form-group">
            <div class="row marges">
                <div class="col y_items_center">
                    <p class="read">
                        <strong>{{ 'sca.valid.value' | translate }} : </strong>
                        @if(society.isValidMangoPaySca) {
                            <span>{{ 'yes.value' | translate }}</span>
                        } @else {
                            <span>{{ 'no.value' | translate }}</span>
                        }
                    </p>
                </div>
            </div>
        </div>
    </div>

    @let documents = (documents$ | async);
    @if (documents) {

        @if(documents.length) {
            <div class="ligne_form">
                <div class="form-group">
                    <div class="row marges">
                        <div class="col y_items_center">
                            <p class="read">
                                <strong>{{ 'mangopay.document.plural.state.value' | translate }} :</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="ligne_form row marges">

            <div class="col_12">

                <div class="form-group">

                    <div class="row marges">

                        @for(document of documents; track document) {
                            <div class="col_4 y_content_start">

                                <div class="read_composition_option col_12">

                                    <p class="read">
                                        <strong>{{ 'mangopay.document.name.value' | translate }} : </strong>
                                        {{ getDocumentLabel(document.type, document.documentType) }}
                                    </p>

                                    <p class="read">
                                        <strong>{{ 'mangopay.document.state.value' | translate }} : </strong>
                                        {{ ('mangopay.document.state.' + (document.status ? document.status : 'notSubmitted') + '.value') | translate }}
                                        @if(document.errors) {
                                            <span>
                                                @let errors = (document.errors | keyvalue);

                                                @for (error of errors; track error.key) {
                                                    <br/>
                                                    {{ 'services.form.identityVerification.document.refusalReason.' + error.key + '.value' | translate }}
                                                    @if(error.value) {
                                                        ({{ error.value }})
                                                    }
                                                }
                                        </span>
                                        }
                                    </p>

                                </div>

                            </div>
                        }

                    </div>

                </div>

            </div>

        </div>

    }

    @let societyServices = (societyServices$ | async);
    @if (societyServices) {

        @if(societyServices.length) {
            <div class="ligne_form">
                <div class="form-group">
                    <div class="row marges">
                        <div class="col y_items_center">
                            <p class="read">
                                <strong>{{ 'societyService.list.subscribed.value' | translate }} :</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="ligne_form row marges">

            <div class="col_12">

                <div class="form-group">

                    <div class="row marges">

                        @for(societyService of societyServices; track societyService) {
                            <div class="col_4 y_content_start">

                                <div class="read_composition_option col_12">

                                    <p class="read">
                                        <strong>{{ 'service.name.value' | translate }} : </strong>
                                        {{ translationService.getFallbackTranslation(societyService.service.translations).name }}
                                    </p>

                                    <p class="read">
                                        <strong>{{ 'service.subscription.date.value' | translate }} : </strong>
                                        {{ (societyService.createdAt | date : 'fullDate' : null: localeId) | titlecase }}
                                    </p>

                                    @if(societyService.service.isWithSubscription) {

                                        <p class="read">
                                            <strong>{{ 'subscription.form.periodicity.value' | translate }} : </strong>
                                            {{ (societyService.periodicity === 'M' ? 'periodicity.monthly.value' : 'periodicity.yearly.value') | translate }}
                                        </p>

                                    }

                                    @if((societyService.service.monthlyPriceHT > 0) || (societyService.service.yearlyPriceHT > 0)) {

                                        <p class="read">
                                            <strong>{{ 'services.payment.amount.value' | translate }} : </strong> {{ formatPrice(societyService.total + (societyService.total * societyService.vatPercent), 'TTC') }}
                                            (<span class="price_ht">{{ formatPrice(societyService.total, 'HT') }}</span>)
                                        </p>

                                    }

                                    @if(societyService.toDelete && societyService.toDeleteAt) {

                                        <p class="read">
                                            <strong>{{ 'service.subscription.toDeleteAt.value' | translate }} : </strong>
                                            {{ societyService.toDeleteAt | date : 'shortDate' : null: localeId }}
                                        </p>

                                    }

                                </div>

                            </div>
                        }

                    </div>

                </div>

            </div>

        </div>

    }

</ng-template>
